<template>
  <basic-container>
    <avue-crud :option="option" v-model:search="search" v-model="form" :data="data" ref="crud" :page.sync="page"
      @refresh-change="onLoad" @on-load="onLoad">
    </avue-crud>
  </basic-container>
</template>

<script>
import { getSmartDevicePageNew } from '@/api/nursingHome/elderDevice';
export default {
  props: {
    row: {
      default: {},
    }
  },
  data() {
    return {
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeName',
          },
          {
            label: '设备名称',
            prop: 'name',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备IMEI',
            prop: 'deviceSerial',
          },
          {
            label: '设备型号',
            prop: 'deviceModelName',
          },
          {
            label: '设备类型',
            prop: 'deviceTypeName',
          },
          {
            label: '所属设备大类',
            prop: 'deviceCategoryName',
          },

          {
            label: '使用人姓名',
            prop: 'elderlyName',
          },
          {
            label: '使用人联系方式',
            prop: 'elderlyTel',
          },
          {
            label: '设备使用状态',
            prop: 'useStatusValue',
          },
          {
            label: '在线状态',
            prop: 'onlineStatusValue',
          },
        ],
      },
      data: []
    };
  },
  created() {
  },
  methods: {
    // onLoad() {
    //   console.log(this.row, 'row');
    //   this.loading = true;
    //   getList(
    //     {
    //       nursinghomeId: this.row.id,
    //     }
    //   ).then(res => {
    //     this.data = res.data;
    //     this.loading = false;
    //   });
    // }

    onLoad() {
      this.loading = true;
      getSmartDevicePageNew(
        Object.assign(
          {},
          {
            current: this.page.currentPage, size: this.page.pageSize, nursinghomeId: this.row.nursinghomeId, elderlyId: this.row.id
          }
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<style></style>
